<template>
  <div>
    <login-student v-if="howComponent === 'login'"/>
    <register-student v-if="howComponent === 'register'"/>
    <div class="container is-6 centralized container-links" v-if="howComponent === 'login'">
      <p style="display:inline-block">Não tem uma conta?</p>
      <a href="#" class="links" @click="changeView('register')">Cadastre-se!</a>
    </div>
    <div class="container is-6 centralized container-links" v-if="howComponent === 'register'">
      <p style="display:inline-block">Já tem uma conta?</p>
      <a href="#" class="links" @click="changeView('login')">Fazer login!</a>
    </div>
  </div>
</template>

<script>
import LoginStudent from './components/login-student'
import RegisterStudent from './components/register-student'
export default {
  name: 'ContainerStudent',
  components: {
    LoginStudent,
    RegisterStudent
  },
  props: {
    howComponent: {
      required: true
    }
  },
  data: () => ({
    showLogin: true,
    showRegister: false
  }),
  methods: {
    changeView (component) {
      this.howComponent = component
    }
  }
}
</script>

<style>
.h2-title {
  position: relative;
  font-size: 1.2em;
  /* color: #0873b4; */
  color: rgb(189, 114, 28);
  border-bottom: solid 1px #dedfe0;
  font-weight: 520;
  padding: 0 0 1rem 0;
  margin: 1rem 0 1.2rem 0;
  text-align: center;
}
.div-logo {
  text-align: center;
  padding-top: 10px;
}
.h3-title {
  color: rgb(189, 114, 28);
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  line-height: 1.3em;
  margin: 20px 0px 5px 0px;
  font-weight: 700;
  padding: 0 30px 0 20px;
  font-size: 0.9rem;
}
.centralized {
  text-align: center;
}
.button-width {
  width: 100%;
}
.input-margin {
  margin-bottom: 1rem;
}
.links {
  margin: 0 0.2rem;
  font-weight: 600;
  text-decoration: none;
  color: #007791;
}
.container-links{
  padding: 2rem 0 2rem 0 !important;
}
</style>
